/**
 * Build a centered react-image-crop percent crop from natural pixel size (source image space).
 * @param {number} cropW
 * @param {number} cropH
 * @param {number} naturalW
 * @param {number} naturalH
 * @returns {{ unit: 'pct', x: number, y: number, width: number, height: number }}
 */
export default function naturalPixelsToPercentCrop(cropW, cropH, naturalW, naturalH) {
  let cw = Math.min(Math.max(1, Math.round(cropW)), naturalW);
  let ch = Math.min(Math.max(1, Math.round(cropH)), naturalH);
  let left = Math.round((naturalW - cw) / 2);
  let top = Math.round((naturalH - ch) / 2);
  if (left < 0) left = 0;
  if (top < 0) top = 0;
  if (left + cw > naturalW) cw = naturalW - left;
  if (top + ch > naturalH) ch = naturalH - top;
  return {
    unit: '%',
    x: (left / naturalW) * 100,
    y: (top / naturalH) * 100,
    width: (cw / naturalW) * 100,
    height: (ch / naturalH) * 100,
  };
}
